import { render, staticRenderFns } from "./RoomTooltip.vue?vue&type=template&id=ef440a4a&"
import script from "./RoomTooltip.vue?vue&type=script&lang=js&"
export * from "./RoomTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports